var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden bg-gray p-2"},[_c('b-row',{staticClass:"my-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('iframe',{staticClass:"pdf",attrs:{"src":_vm.url+'#toolbar=0'}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }